module.exports = __webpack_public_path__ + "img/hots.e440c07a.png";